import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import { URL } from '~/config/uri';
export default class PushRecord extends RecordBase {

  static defaultAttributes = {
    user_id:                      '',
    image_id:                     null,
    image_url:                    null,
    title:                        '',
    subtitle:                     '',
    message:                      '',
    link_url:                     '',
    template_id:                  null,
    sent_at:                      '',
    send_at:                      '',
    filter:                       '',
    image:                        {},
    image_base64:                 null,
    title_en:                     '',
    message_en:                   '',
    subtitle_en:                  '',
    title_es:                     '',
    subtitle_es:                  '',
    message_es:                   '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`push.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        user_id:            trAttr('user_id'),
        image_id:           trAttr('image_id'),
        image_url:          trAttr('image_url'),
        title:              trAttr('title'),
        subtitle:           trAttr('subtitle'),
        message:            trAttr('message'),
        link_url:           trAttr('link_url'),
        template_id:        trAttr('template_id'),
        sent_at:            trAttr('sent_at'),
        send_at:            trAttr('send_at'),
        filter:             trAttr('filter'),
        image:              trAttr('image'),
        image_base64:       trAttr('image_base64'),
        title_en:           trAttr('title_en'),
        message_en:         trAttr('message_en'),
        subtitle_en:        trAttr('subtitle_en'),
        title_es:           trAttr('title_es'),
        subtitle_es:        trAttr('subtitle_es'),
        message_es:         trAttr('message_es'),
        users_received:     trAttr('users_received'),
      };
    }

    return this._attributeNames;
  }

  getImageUrl(){
    return `${URL}${this.get('image').file_path}`;
  }

  toParams(attrs={}){
    const {
      image_id,
      image_url,
      title,
      subtitle,
      message,
      link_url,
      template_id,
      send_at,
      filter,
      title_en,
      subtitle_en,
      message_en,
      title_es,
      subtitle_es,
      message_es,
    } = this.toObject();

    return {
      data:{
        attributes:{
          image_id,
          image_url,
          title,
          subtitle,
          message,
          link_url,
          template_id,
          send_at,
          filter,
          title_en,
          subtitle_en,
          message_en,
          title_es,
          subtitle_es,
          message_es,
          ...attrs
        }
      }
    };
  }
}
